/* External dependencies */
import update from 'react-addons-update';

/* Local dependencies */
import { PinCodeValidationActions, PinCodeValidationActionTypes } from './actions';

interface PinCodeValidationState {
  values: string[];
  error: null | string;
  isValid: boolean;
  counter: number;
  isCounterEnded: boolean;
}

const initialState: PinCodeValidationState = {
  values: ['', '', '', '', '', ''],
  error: null,
  isValid: false,
  counter: 30,
  isCounterEnded: false,
};

export function pinCodeValidationReducer(
  state: PinCodeValidationState = initialState,
  action: PinCodeValidationActions,
) {
  switch (action.type) {
    case PinCodeValidationActionTypes.INPUT_VALUES:
      return update(state, {
        values: { $set: action.values },
        error: { $set: null },
      });

    case PinCodeValidationActionTypes.PINCODE_SUBMIT:
      const values = action.values;
      if (values.some((value: string) => value === '')) {
        return update(state, { error: { $set: action.errorMessage } });
      } else {
        return update(state, { isValid: { $set: true } });
      }

    case PinCodeValidationActionTypes.COUNTER_RESET:
      if (state.isCounterEnded === true) {
        return update(state, {
          isCounterEnded: { $set: false },
          counter: { $set: initialState.counter },
        });
      }

    case PinCodeValidationActionTypes.COUNTER_DECREMENT:
      if (state.counter === 0) {
        return update(state, {
          isCounterEnded: { $set: true },
        });
      }
      return update(state, {
        counter: { $set: state.counter - 1 },
      });

    case PinCodeValidationActionTypes.RESET_STATE:
      return { ...initialState };
      
    default:
      return state;
  }
}
